// src/components/.../News.js
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ApiService from "../../../network/ApiService";
import engToNepNumber from "../../../helpers/EngToNepNumber";
import { Lightbox } from "yet-another-react-lightbox";
import { Thumbnails } from "yet-another-react-lightbox/plugins";

function News(props) {
  // Get orgId from Redux store
  const { organizationId } = useSelector((state) => state.organization);

  // Destructure API functions from ApiService
  const {
    fetchNewsUpdates,
    fetchContact,
    fetchAboutUs,
    fetchSliderImages,
    fetchStaffs,
    fetchGalleries,
  } = ApiService();

  const [newsList, setNewsList] = useState([]);
  const [activeArray, setActiveArray] = useState(null);
  const [splicedNews, setSplicedNews] = useState([]);
  const [open, setOpen] = useState(false);
  const [slides, setSlides] = useState([]);
  const languageStatus = sessionStorage.getItem("language");

  // --- Fetch news from API ---
  const getNewsList = async () => {
    try {
      // If API expects orgId, pass it
      const response = await fetchNewsUpdates(organizationId);
      // console.log("fetchNewsUpdates response:", response?.data);

      const data = response?.data ?? {};
      // Fallback for various backend response keys
      const list =
        data.aboutUsNewsAndImg ??
        data.newsList ??
        data.noticeList ??
        data.items ??
        [];

      const arr = Array.isArray(list) ? list : [];
      setNewsList(arr);
      setActiveArray(arr.length > 0 ? arr[0] : null);
    } catch (error) {
      console.error("getNewsList error:", error?.message || error);
      setNewsList([]);
      setActiveArray(null);
    }
  };

  // --- Switch active news item ---
  const getActiveTab = (index) => {
    setActiveArray(newsList[index]);
  };

  // --- Convert HTML strings to renderable content ---
  const parseHtmlToView = (str) => {
    return { __html: str };
  };

  // --- Handle props or API fetch ---
  useEffect(() => {
    if (props.newsList && props.newsList.length > 0) {
      setNewsList(props.newsList);
      setActiveArray(props.newsList[0] ?? null);
    } else if (organizationId) {
      getNewsList();
    }
  }, [organizationId, props.newsList]);

  // --- For news detail page: exclude current item ---
  useEffect(() => {
    if (props.newsDetails && props.newsDetailId) {
      const filteredList = newsList.filter(
        (news) => news.newsId !== Number(props.newsDetailId)
      );
      setSplicedNews(filteredList.slice(0, 3)); // limit to 3
    }
  }, [newsList, props.newsDetailId]);

  // --- Lightbox handling ---
  const handleViewSlides = (galleryImages) => {
    const images = galleryImages.map((value) => ({
      src: value,
      alt: "image",
      width: 3840,
      height: 2560,
    }));
    setSlides(images);
    setOpen(true);
  };

  // --- UI Render ---
  return (
    <>
      {window.location.pathname === "/news" ? (
        <>
          {newsList && newsList.length > 0 ? (
            <div className="tm-page">
              <div className="uk-section uk-section-default">
                <div className="uk-container">
                  <div className="tm-grid-expand">
                    <h2 className="uk-h2 uk-margin-large uk-text-center">
                      <span className="underline-secondary">
                        {languageStatus === "en" ? "News" : "समाचार"}
                      </span>
                    </h2>
                  </div>
                  <div className="uk-grid">
                    {/* Left side list */}
                    <div className="uk-width-1-5@m">
                      <div
                        className="uk-tab-left"
                        uk-tab="connect: #component-tab-left; animation: uk-animation-fade"
                      >
                        {newsList.map((data, index) => (
                          <div key={`link_div_${index}`}>
                            <a href="#" onClick={() => getActiveTab(index)}>
                              {languageStatus === "en"
                                ? data.header ?? data.headerNp
                                : data.headerNp ?? data.header}
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Right side active news */}
                    <div className="uk-width-expand@m">
                      {activeArray ? (
                        <div
                          className="uk-card uk-card-default uk-card-small uk-margin-remove-first-child uk-margin"
                          key={`main_${activeArray.id}`}
                        >
                          {activeArray.imageUrl !== "n/a" && (
                            <div className="uk-card-media-top">
                              <div className="aspect-square">
                                <img
                                  decoding="async"
                                  src={
                                    activeArray.imageUrl !== "n/a"
                                      ? activeArray.imageUrl
                                      : `assets/images/image.jpg`
                                  }
                                  className="el-image"
                                  alt=""
                                  loading="lazy"
                                />
                              </div>
                            </div>
                          )}
                          <div className="uk-card-body uk-margin-remove-first-child">
                            <h3 className="el-title uk-card-title uk-margin-top uk-margin-remove-bottom">
                              {languageStatus === "en"
                                ? activeArray.header ?? activeArray.headerNp
                                : activeArray.headerNp ?? activeArray.header}
                            </h3>
                            <div
                              className="el-content"
                              style={{ color: "black" }}
                              dangerouslySetInnerHTML={parseHtmlToView(
                                (languageStatus === "en"
                                  ? activeArray.message ?? activeArray.messageNp
                                  : activeArray.messageNp ??
                                    activeArray.message
                                )
                                  .split("<p><br></p>")
                                  .join("")
                              )}
                            ></div>
                          </div>

                          {/* Gallery */}
                          {activeArray.galleryUrls &&
                            activeArray.galleryUrls.length > 0 && (
                              <div className="uk-flex uk-flex-column">
                                <h3 className="uk-text-center">
                                  {languageStatus === "en"
                                    ? "Related Images"
                                    : "सम्बन्धित चित्रहरू"}
                                </h3>
                                <div className="uk-flex uk-flex-center uk-border-rounded">
                                  <Lightbox
                                    open={open}
                                    close={() => setOpen(false)}
                                    slides={slides}
                                    plugins={[Thumbnails]}
                                    carousel={{ finite: true }}
                                  />
                                  <div
                                    className="uk-card uk-column-span news-gallery-image uk-overflow-hidden uk-margin-small-bottom"
                                    style={{
                                      cursor: "pointer",
                                      border: "1px solid #9E9E9E",
                                      padding: "5px",
                                      borderRadius: "5px",
                                    }}
                                    onClick={() =>
                                      handleViewSlides(activeArray.galleryUrls)
                                    }
                                  >
                                    <img
                                      decoding="async"
                                      className="el-image"
                                      alt=""
                                      loading="lazy"
                                      src={
                                        activeArray.galleryUrls &&
                                        activeArray.galleryUrls[0] !== "n/a"
                                          ? activeArray.galleryUrls[0]
                                          : "assets/images/image.jpg"
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                        </div>
                      ) : (
                        <div
                          style={{
                            border: "1px solid",
                            borderRadius: "5px",
                            padding: "5px",
                          }}
                        >
                          <div
                            className="uk-flex-wrap-bottom uk-text-bold"
                            style={{ fontSize: "24px" }}
                          >
                            {languageStatus === "en"
                              ? "News Not Found"
                              : "समाचार भेटियन"}
                            ...
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                border: "1px solid",
                borderRadius: "5px",
                padding: "5px",
              }}
            >
              <div
                className="uk-flex-wrap-bottom uk-text-bold"
                style={{ fontSize: "24px" }}
              >
                {languageStatus === "en"
                  ? "News Not Found"
                  : "समाचार भेटियन"}
                ...
              </div>
            </div>
          )}
        </>
      ) : (
        // --- Sidebar compact news view ---
        <div className="uk-width-1-2@m uk-first-column">
          <h2 data-id="page#7-0-0-0" className="uk-margin-large uk-h2">
            <span className="underline-secondary">
              {props.language === "en" ? "News" : "समाचार"}
            </span>
          </h2>
          {newsList && newsList.length > 0 ? (
            <div
              style={{
                maxHeight: "520px",
                overflowY: "auto",
                paddingRight: "10px",
                border: "1px solid #ddd",
                borderRadius: "5px",
              }}
            >
              {newsList.map((data, index) => (
                <div
                  className="uk-card uk-card-default uk-card-small uk-card-body uk-margin-remove-first-child uk-margin"
                  key={index}
                >
                  <h3 className="el-title uk-card-title uk-margin-top uk-margin-remove-bottom">
                    <Link
                      to={`/news-detail/${data.newsId}`}
                      style={{ color: "#2c3e94", textDecoration: "none" }}
                    >
                      {props.language === "en"
                        ? data.header ?? data.headerNp
                        : data.headerNp ?? data.header}
                    </Link>
                  </h3>
                  <div className="el-meta uk-text-meta uk-margin-small">
                    {props.language === "en"
                      ? data.newsDateEn ?? data.newsDate
                      : engToNepNumber(data.newsDate)}{" "}
                    &nbsp;
                    {props.language === "en"
                      ? data.newsTime
                      : engToNepNumber(data.newsTime.split(" ")[0]) +
                        " " +
                        data.newsTime
                          .split(" ")[1]
                          .replace("AM", "बिहान")
                          .replace("PM", "बेलुका")}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{
                border: "1px solid",
                borderRadius: "5px",
                padding: "5px",
              }}
            >
              <div
                className="uk-flex-wrap-bottom uk-text-bold"
                style={{ fontSize: "24px" }}
              >
                {languageStatus === "en"
                  ? "News Not Found"
                  : "समाचार भेटियन"}
                ...
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default News;
